<template>
  <div
    class="modal-mask"
    @mousedown.self.stop="closeModal()"
  >
    <Form class="modal" @request="saveInfo">
      <div class="modal__head">
        <h3 class="modal__title">
          {{ hasUpdated ? "Редактировать чат" : "Создать чат" }}
        </h3>
        <div
          class="close"
          @click.stop="closeModal()"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="page__row name__group">
          <div class="page__item input-name">
            <VInput
              label="Название чата:"
              width="100%"
              :value="name"
              @input="setRoomName"
              required
            >
              <Validation for="required">Поле обязательно</Validation>
            </VInput>
          </div>
          <div class="page__item">
            <AppColorPicker
              title="Цвет:"
              :value="color"
              @input="setRoomColor"
            />
          </div>
        </div>

        <!-- tabs -->
        <div class="tabs">
          <div class="tab__list">
            <span
              v-for="(item, i) in tabs"
              :key="i + 'tabName'"
              :class="['tab__list-item', { active: activeTabIndex === i }]"
              @click="activeTabIndex = i"
            >{{ item.name }}</span
            >
          </div>

          <div
            v-if="activeTabIndex === 0"
            class="tabs__content" ref="tabContent"
          >
            <SearchForm
              dynamic
              v-if="activeTabIndex === 0"
              :value="searchValue"
              @form-submit="searchUser"
              style="margin-right: 22px; width: auto; margin-bottom: 12px;"
            />
            <div
              v-for="(item, i) in filteredUserList"
              :key="i + 'tabVal'"
              class="tabs__content-item"
              ref="tabContentItems"
            >
              <div class="item">
                <div class="user-avatar">
                  <img
                    v-if="item.avatar && item.avatar.file_size"
                    :src="item.avatar.url"
                    :alt="item.name"
                  />
                  <img v-else src="/img/avatar-thumb.png" :alt="item.name"/>
                </div>
                <div class="item__name">
                  <span class="item__name-user">
                    {{ item.name }}
                  </span>
                </div>

                <AppCheckbox
                  @toggle-check="toggleUser(item)"
                  :checked="item.isActive"
                  style="margin-left: auto; margin-right:22px"
                />
              </div>
            </div>
          </div>

          <div
            v-if="activeTabIndex === 1"
            class="tabs__content" ref="tabContent"
          >
<!--            <SearchForm-->
<!--              v-if="activeTabIndex === 1"-->
<!--              :value="searchValueGroup"-->
<!--              @form-submit="searchGroup"-->
<!--              style="margin-right: 22px; width: auto; margin-bottom: 12px;"-->
<!--            />-->

            <div
              v-for="(groupId, i) in groupListMap.keys()"
              :key="i + 'groupVal'"
              class="tabs__content-item"
              ref="tabContentItems"
            >
              <div class="item">
                <div class="group-avatar" :style="`background: ${ groupListMap.get(groupId)[0].groups[0].color}; box-shadow: 0 0 0 2px ${ groupListMap.get(groupId)[0].groups[0].color};`">
                  <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.578 3.83416C17.578 5.27849 16.3678 6.44934 14.8749 6.44934C13.382 6.44934 12.1717 5.27849 12.1717 3.83416C12.1717 2.38984 13.382 1.21898 14.8749 1.21898C16.3678 1.21898 17.578 2.38984 17.578 3.83416ZM18.838 3.83416C18.838 5.3158 17.9694 6.60116 16.6978 7.23953C17.8624 7.59073 18.896 8.27178 19.6617 9.19962C20.3529 10.0372 20.793 11.0363 20.9427 12.0882H21V13.3072H12.1045C12.1404 13.4639 12.1697 13.622 12.1924 13.781H12.2497V14.5871V14.5901V15H0V14.5901V13.781H0.0573702C0.128603 13.2811 0.265722 12.7909 0.466228 12.3225C0.774031 11.6036 1.22519 10.9504 1.79393 10.4002C2.36268 9.84993 3.03788 9.41346 3.78098 9.11567C3.95197 9.04715 4.12578 8.98629 4.30187 8.93317C3.03027 8.29483 2.16151 7.00943 2.16151 5.52772C2.16151 3.41017 3.93587 1.69356 6.12466 1.69356C8.31345 1.69356 10.0878 3.41017 10.0878 5.52772C10.0878 7.00937 9.21913 8.29472 7.94761 8.9331C8.12379 8.98623 8.29768 9.04712 8.46876 9.11567C8.89639 9.28704 9.30154 9.50433 9.67685 9.76281C10.2865 8.81627 11.1628 8.05132 12.2088 7.56198C12.4826 7.43388 12.7645 7.32633 13.0521 7.23961C11.7805 6.60126 10.9117 5.31586 10.9117 3.83416C10.9117 1.71661 12.6861 0 14.8749 0C17.0637 0 18.838 1.71661 18.838 3.83416ZM11.677 12.0882H19.7133C19.5733 11.304 19.2309 10.5618 18.7121 9.93304C18.0176 9.09141 17.0481 8.50309 15.9625 8.26457C14.877 8.02604 13.7399 8.15147 12.7378 8.62028C11.8389 9.04079 11.0964 9.71518 10.6059 10.5506C11.0442 11.0057 11.4056 11.5246 11.677 12.0882ZM8.82782 5.52772C8.82782 6.97205 7.61758 8.1429 6.12466 8.1429C4.63175 8.1429 3.4215 6.97205 3.4215 5.52772C3.4215 4.0834 4.63175 2.91254 6.12466 2.91254C7.61758 2.91254 8.82782 4.0834 8.82782 5.52772ZM11.0426 13.781H1.20719C1.26962 13.4259 1.37311 13.0777 1.51629 12.7433C1.76697 12.1578 2.13441 11.6258 2.59761 11.1777C3.06082 10.7296 3.61072 10.3741 4.21593 10.1316C4.82114 9.88903 5.4698 9.7642 6.12487 9.7642C6.77994 9.7642 7.4286 9.88903 8.03381 10.1316C8.63902 10.3741 9.18892 10.7296 9.65213 11.1777C10.1153 11.6258 10.4828 12.1578 10.7335 12.7433C10.8766 13.0777 10.9801 13.4259 11.0426 13.781Z" fill="currentColor"/>
                  </svg>
                </div>

                <div class="item__name">
                  <span class="item__name-user">
                    {{ groupListMap.get(groupId)[0].groups[0].name }}
                  </span>
                </div>

                <AppCheckbox
                  @toggle-check="toggleGroup(groupId)"
                  :checked="groupListMap.get(groupId)[0].groups[0].isGroupActive"
                  style="margin-left: auto; margin-right:22px"
                />
              </div>
            </div>
          </div>

          <div
            v-if="activeTabIndex === 2"
            class="tabs__content" ref="tabContent"
          >
<!--            <SearchForm-->
<!--              v-if="activeTabIndex === 2"-->
<!--              :value="searchValueDepartment"-->
<!--              @form-submit="searchDepartment"-->
<!--              style="margin-right: 22px; width: auto; margin-bottom: 12px;"-->
<!--            />-->

            <div
              v-for="(departmentId, i) in departmentListMap.keys()"
              :key="i + 'departmentVal'"
              class="tabs__content-item"
              ref="tabContentItems"
            >
              <div class="item">
                <div class="item__name">
                  <span class="item__name-user">
                    {{ departmentListMap.get(departmentId)[0].department.name }}
                  </span>
                </div>

                <AppCheckbox
                  @toggle-check="toggleDepartment(departmentId)"
                  :checked="departmentListMap.get(departmentId)[0].department.isDepartmentActive"
                  style="margin-left: auto; margin-right:22px"
                />
              </div>

            </div>
          </div>
        </div>

        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton title="Сохранить" type="main"/>
          </div>
          <div class="modal__button">
            <AppButton
              title="Отмена"
              type="alt"
              @click.native="closeModal"
            />
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import VInput from '@/components/page/Form/Vinput/Vinput'
import Form from '@/components/page/Form/Form'
import Validation from '@/components/page/Form/Validation'
import AppColorPicker from '@/components/page/input/AppColorPicker'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import SearchForm from '@/components/page/input/SearchForm'
import axios from 'axios'
import { config, url } from '@/store'
import { centrifugePublish } from '@/api/centrifuge'

export default {
  name: 'DialogRoomModal',
  components: {
    Form,
    VInput,
    Validation,
    AppColorPicker,
    AppButton,
    AppCheckbox,
    SearchForm
  },
  props: {
    state: {
      type: Object,
      default: () => {
        return {}
      }
    },
    users: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      tabs: [
        { name: 'Сотрудники', value: 'users' },
        { name: 'Группы', value: 'groups' },
        { name: 'Отделы', value: 'departments' }
      ],
      activeTabIndex: 0,

      name: '',
      color: '#9DCBEE',

      searchValue: '',
      filteredUserList: [],

      // searchValueGroup: '',
      // searchValueDepartment: '',

      usersChecked: [],
      // groups: [],
      // departments: [],

      hasUpdated: false
    }
  },

  beforeDestroy () {
    this.clearModalChat()
  },

  mounted () {
    this.filteredUserList = [...this.userListMap]
    if (this.state.updatedId) {
      this.hasUpdated = true
      console.log('this.state.color', this.state.color)
      this.setRoomColor(this.state.color)
      this.setRoomName(this.state.name)
      this.mountedCheckedUser()
    }
  },

  computed: {
    userListMap () {
      return this.users
        .filter(user => user.id !== this.currentUser.id)
        .map(user => {
          return {
            ...user,
            isActive: false
          }
        })
    },

    groupListMap () {
      const mapGroup = new Map()
      this.userListMap
        .filter(user => user.groups)
        .forEach(user => {
          const old = mapGroup.get(user.groups[0].id) || []
          mapGroup.set(user.groups[0].id, [...old, user])
        })
      return mapGroup
    },

    departmentListMap () {
      const mapDepartment = new Map()
      this.userListMap
        .filter(user => user.department)
        .forEach(user => {
          const old = mapDepartment.get(user.department.id) || []
          mapDepartment.set(user.department.id, [...old, user])
        })
      return mapDepartment
    },

    currentUser () {
      return this.$store.getters.currentUser
    }
  },

  methods: {
    saveInfo () {
      const currentUserId = this.currentUser.id
      const postData = {
        name: this.name,
        color: this.color,
        user_ids: [...this.usersChecked],
        type: 2
      }

      if (this.hasUpdated) {
        axios.put(`${url}/chat/rooms/${this.state.updatedId}`, postData, config).then(() => {
          const expandUserIds = [...postData.user_ids, currentUserId]
          centrifugePublish('channel_system', 'system_update-room-list', { room_id: this.state.updatedId, room_users: expandUserIds, is_updated: true })
          this.closeModal()
        }).catch(error => {
          if (error.response.status === 422) {
            console.log('422', error.response.data.errors)
          } else if (error.response.status === 406) {
            console.log('SET_DIALOG_ROOM_MODAL_VALIDATION', { user_ids: [error.response.data.data] })
          }
          console.log('Ошибка редактирования группового чата', error.response)
        })
      } else {
        axios.post(`${url}/chat/rooms`, postData, config).then(() => {
          const expandUserIds = [...postData.user_ids, currentUserId]
          centrifugePublish('channel_system', 'system_update-room-list', { room_users: expandUserIds })
          this.closeModal()
        }).catch(error => {
          if (error.response.status === 422) {
            console.log('422', error.response.data.errors)
          } else if (error.response.status === 406) {
            console.log('SET_DIALOG_ROOM_MODAL_VALIDATION', { user_ids: [error.response.data.data] })
          }
          console.log('Ошибка создания группового чата', error.response)
        })
      }
    },

    mountedCheckedUser () {
      this.state.members.forEach(item => {
        const user = this.checkedUser(item.id)
        user.isActive = true
        this.usersChecked.push(item.id)
      })
    },
    checkedUser (id) {
      return this.userListMap.find(user => user.id === id)
    },

    clearModalChat () {
      this.userListMap.forEach(user => {
        this.toggleUser(user, false)
        if (user.department) {
          user.department.isDepartmentActive = false
        }
        if (user.groups) {
          user.groups.map(group => {
            group.isGroupActive = false
          })
        }
      })
    },

    closeModal () {
      this.name = ''
      this.color = null
      this.$emit('close-modal')
    },
    setRoomColor (color) {
      this.color = color
    },
    setRoomName (name) {
      this.name = name
    },

    toggleDepartment (departmentId, isActive) {
      const department = this.departmentListMap.get(departmentId)[0].department
      department.isDepartmentActive = isActive || !department.isDepartmentActive

      const active = department.isDepartmentActive
      console.log('active', active)
      this.departmentListMap.get(departmentId)
        .forEach(user => this.toggleUser(user, active))
    },

    toggleGroup (groupId) {
      const group = this.groupListMap.get(groupId)[0].groups[0]
      group.isGroupActive = !group.isGroupActive

      const active = group.isGroupActive
      this.groupListMap.get(groupId)
        .forEach(user => this.toggleUser(user, active))
    },

    toggleUser (user, isActive) {
      user.isActive = isActive || !user.isActive

      if (user.isActive) {
        this.usersChecked.push(user.id)
        this.usersChecked = [...new Set(this.usersChecked)]
      } else {
        this.usersChecked = this.usersChecked.filter(id => id !== user.id)
      }
    },

    // Search
    getUserName (id) {
      return this.userListMap.find(user => user.id === id)?.name || ''
    },
    searchUser (val) {
      this.searchValue = val
      if (val && val.length > 3) {
        this.filteredUserList = this.userListMap.filter(user => {
          const userName = this.getUserName(user.id)?.toLowerCase()
          const searchVal = val.toLowerCase()
          return userName.includes(searchVal)
        })
      } else {
        this.filteredUserList = [...this.userListMap]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group-avatar {
  color: $color_main;
}

.modal-mask {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.6);
}

.modal {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 480px;

  @media screen and (max-width: $tablet_start) {
    top: 0;
    left: 0;
    right: 0;
    transform: translateX(0);
  }

  .input-name {
    width: 100%;
    max-width: 328px;

    @media screen and (max-width: $tablet_start) {
      max-width: unset;
    }
  }

  &__body {
    width: 100%;
    padding: 0;
    margin-top: -40px;
    padding-bottom: 36px;

    .name__group {
      background: #eceef5;
      padding: 32px 30px;
    }

    .tabs {
      padding: 0 18px 32px 25px;

      .tab__list {
        margin-bottom: 21px;
        padding-bottom: 15px;
        margin-right: 16px;
        border-bottom: 3px solid $color_third;
        color: $font_color_second;

        .tab__list-item {
          padding-bottom: 18px;
          margin-right: 32px;
          cursor: pointer;

          &.active {
            color: #122d55;
            border-bottom: 3px solid $color_second-light;
          }
        }
      }

      .tabs__content {
        height: 210px;
        overflow: auto;
        padding-left: 5px;
        padding-top: 5px;

        &::-webkit-scrollbar {
          width: 5px;
        }

        &::-webkit-scrollbar-track {
          background-color: $color_third;
        }

        &::-webkit-scrollbar-thumb {
          background-color: $color_second-light;
        }

        .tabs__content-item {
          display: flex;
          flex-direction: column;
          margin-right: 12px;
          transition: 0.2s;

          &.active {
            border: 1px solid #949dac;
            border-radius: 2px;

            .item {
              background: rgba(208, 231, 247, 0.59);
            }
          }

          .item {
            display: flex;
            align-items: center;
            padding-top: 12px;
            padding-bottom: 12px;
            transition: 0.2s;

            .item__name {
              margin-left: 8px;
              color: #0e619f;

              .item__name-position {
                font-size: 12px;
                color: #949dac;
                line-height: 14px;
              }

              .item__name-user {
                font-size: 14px;
                line-height: 17px;
              }
            }

            .item__icon {
              margin-right: 14px;
              margin-left: 18px;
              cursor: pointer;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }

          .group__users {
            height: 115px;
            overflow: auto;
            margin: 12px;

            .group__users-item {
              padding: 5px;
              display: flex;
              align-items: center;
              color: #0e619f;
              font-size: 14px;
            }

            &::-webkit-scrollbar {
              width: 4px;
            }

            &::-webkit-scrollbar-track {
              background-color: $color_third;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $color_second-light;
            }
          }
        }
      }
    }
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
